<!-- 选择就诊人组件 -->
<template>
	<div>
		<div style="height: 44px;">
			<van-cell class="parentTop" is-link :arrow-direction="arrow" @click="showPopup">
				<template slot="title">
					<span style="font-size:18px;color: #323233;">默认就诊人：</span>
					<span style="font-size:18px;letter-spacing: 3px;">{{ activeValue }}</span>
				</template>
			</van-cell>
		</div>
		<van-popup v-model="show" position="top">
			<van-radio-group v-model="radio">
				<van-cell v-for="item in patientList" :key="item.value" clickable @click="change(item)">
					<template slot="title">
						<span style="font-weight: bold;color: #0ec9ac;" v-if="radio == item.value">{{ item.idcard }}({{ item.text }})</span>
						<span v-else>{{ item.idcard }}({{ item.text }})</span>
					</template>
					<van-radio slot="right-icon" :name="item.value" checked-color="#0ec9ac" />
				</van-cell>
			</van-radio-group>
		</van-popup>
	</div>
</template>

<script>
import { getUserList, setDefault } from '@/api/user';
export default {
	props: {},
  inject: ["reload"],
	data() {
		return {
			show: false, //用户列表弹出层
			arrow: 'down', // 控制箭头方向
			activeValue: '', // 就诊人折叠面板的标题栏右侧内容
			radio: '', // 当前选中的就诊人
			patientList: []
		};
	},
	mounted() {
		getUserList().then(res => {
			this.patientList = res.result;
			for (let index1 in this.patientList) {
				if (this.patientList[index1].ifDefault == '1') {
					this.patientList[index1].selected = 1;
				} else {
					this.patientList[index1].selected = 0;
				}
				this.patientList[index1].text = this.patientList[index1].patientName;
				this.patientList[index1].value = this.patientList[index1].patientId;
			}
			for (let index in this.patientList) {
				if (this.patientList[index].selected == 1) {
					this.activeValue = this.patientList[index].text;
					this.radio = this.patientList[index].patientId;
					// 设置默认事件，将选中值传给父组件中的selected方法
					this.$emit('initDef', this.patientList[index]);
					break;
				}
			}
		}).catch(() => {
      //直接使用
      this.reload()
    })
	},
	methods: {
		showPopup() {
			if (this.show) {
				this.show = false;
				this.arrow = 'down';
			} else {
				this.show = true;
				this.arrow = 'up';
			}
		},
		change(item) {
			this.activeValue = item.text;
			this.radio = item.value;
			//切换就诊人就设置成默认就诊人
			setDefault({ patientId: item.patientId }).then(res => {
				if (res.success) {
					this.show = false;
					this.arrow = 'down';
					// 设置默认事件，将选中值传给父组件中的selected方法
					this.$emit('selected', item.value, item.text, item);
				}
			});
		}
	}
};
</script>

<style scoped="scoped">
.parentTop {
	position: fixed;
	z-index: 999999;
	height: 44px;
	box-shadow: 0 0.4px 1px 0 rgba(0, 0, 0, 0.2);
}
.van-popup--top {
	top: 44px;
	left: 0;
	width: 100%;
}
</style>
